import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './assets/main.css'; // 替换为你的自定义 CSS 文件
import '@fortawesome/fontawesome-free/css/all.min.css';
import router from './router';
import axios from 'axios';

const app = createApp(App);

app.use(ElementPlus);
app.use(router);

app.config.globalProperties.$axios = axios;

app.mount('#app');